import PreviewFile from "./index.vue";

const svgIconPlugin: any = {
  name: "PreviewFile",
  install(app: any): void {
    app.component("PreviewFile", PreviewFile);
  }
};

export default svgIconPlugin;
